module.exports = __webpack_public_path__ + "static/media/fullAMRewardsBlue.d0a9e729.svg";